import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Alarmclock = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 16C28 14.15 27.575 12.4 26.825 10.825C27.575 10.087 28 9.075 28 8C28 5.8 26.2 4 24 4C22.913 4 21.913 4.425 21.175 5.175C19.612 4.425 17.85 4 16 4C14.15 4 12.4 4.425 10.825 5.175C10.087 4.425 9.075 4 8 4C5.8 4 4 5.8 4 8C4 9.087 4.425 10.087 5.175 10.825C4.425 12.388 4 14.15 4 16C4 19.375 5.4 22.413 7.638 24.6L6.226 26.375C5.876 26.813 5.951 27.438 6.376 27.775C6.564 27.925 6.776 28 7.001 28C7.288 28 7.589 27.875 7.788 27.625L9.188 25.875C11.126 27.212 13.475 28 16.001 28C18.527 28 20.876 27.212 22.814 25.875L24.214 27.625C24.414 27.875 24.702 28 25.002 28C25.227 28 25.44 27.925 25.627 27.775C26.065 27.425 26.127 26.8 25.777 26.375L24.352 24.6C26.602 22.412 28.002 19.375 28.002 16H28ZM24 6C25.1 6 26 6.9 26 8C26 8.363 25.913 8.7 25.738 9C24.976 7.95 24.063 7.025 23.013 6.275C23.301 6.087 23.638 6 24.001 6H24ZM8 6C8.363 6 8.7 6.088 9 6.263C7.95 7.026 7.025 7.951 6.263 9C6.088 8.7 6 8.363 6 8C6 6.9 6.9 6 8 6ZM16 26C10.488 26 6 21.512 6 16C6 10.488 10.488 6 16 6C21.512 6 26 10.488 26 16C26 21.512 21.512 26 16 26Z" />
		<path d="M21.525 18.15L17 15.437V10.999C17 10.449 16.55 9.99902 16 9.99902C15.45 9.99902 15 10.449 15 10.999V15.999C15 16.349 15.188 16.674 15.488 16.861L20.488 19.861C20.638 19.948 20.813 19.998 21 19.998C21.55 19.998 22 19.548 22 18.998C22 18.635 21.812 18.323 21.525 18.148V18.15Z" />
	</svg>
);

export default Alarmclock;
